var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"serback"},[_c('div',{staticClass:"serback_content"},[_vm._v("\n    非常感谢您对我们此次的配合！\n    您所提供的信息对我们今后工作非常有价值，\n    我们将会把相关信息进行综合分析，希望我们的调查能对您有所帮助！\n  ")]),_vm._v(" "),_c('div',{staticClass:"serback_back"},[_c('button',{staticClass:"serback_back_btn",on:{"click":_vm.fanhui}},[_vm._v("返回试卷列表")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8265be10","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/servey/serback.vue
// module id = null
// module chunks = 